



<div class="_dialog-title">
	<mat-icon svgIcon="logo" class="me-2"></mat-icon>
	<span>{{'TO.table_number_title' | translate}}</span>
</div>

<div class="_dialog-content" >
	<!--<div class="_sub-title pre-wrap" >{{'TO.enter_table_number' | translate}}</div>-->
	<div class="keypad-val-container">
		<div class="keypad-val brand-input-border" [class._hasVal]="ui.connectValue?.length">
			<div class="_cap">{{'TO.enter_table_number' | translate}}</div>
			<div class="_val" [class.text-danger]="ui.connectOptions.invalid">{{ui.connectValue}}</div>
		</div>
	</div>
	<app-inline-keypad #loginKeypad [data]="ui.connectOptions" (onChange)="onTableNumberChange($event)"></app-inline-keypad>
</div>

<div class="_bottom-actions mt-4">
	<button mat-button color="accent"  (mousedown)="close()">{{'Cancel' | translate}}</button>
	<button type="button" mat-flat-button color="accent" class="rounded" (mousedown)="applyEatin()" [disabled]="!ui.connectValid" style="min-width: 120px">{{'continue' | translate}}</button>
</div>
@if (data.enableTakeaway) {
	<div class="text-center mt-4">
		<a class="text-accent text-center p-2" style="font-size: 13px; font-weight: 500" (mousedown)="applyTakeAway()">
			<span>{{'TO.takeaway_instead' | translate}}</span>
		</a>
	</div>
}
